<div class="container" [ngSwitch]="mode">

    <div *ngSwitchDefault>
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
      <table *ngIf="!isLoading" style="width:100%">
        <tr  class="back">
          <th>Name</th>
          <th>Price</th>
          <th>
            <button class="add" mat-raised-button color="basic" (click)="addNew()">
              Add New
            </button>
          </th>
        </tr>
        <tr class="td" *ngFor="let opd of opds">
          <td>{{opd.package_name}}</td>
          <td>{{opd.pack_price}}</td>
          <td>
            <button mat-raised-button color="primary" (click)=" edit(opd)">
              Edit
            </button>
            <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="delete(opd)">
              Delete
            </button>
          </td>
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="last">
      </div>
    </div>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
      <div class="post">
        <div class="title">Create OPD</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input formControlName="package_name" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Price</mat-label>
                <input formControlName="pack_price" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Tot Serve Price</mat-label>
                <input formControlName="tot_serv_price" type="number" matInput placeholder="Imo">
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Net Amount</mat-label>
                <input formControlName="net_amt" type="number" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Soc</mat-label>
                <mat-select formControlName="soc_id" matNativeControl required (selectionChange)="socChange($event)">
                  <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">
                    {{soc.SOC_NAME}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Department</mat-label>
                <mat-select formControlName="dept_id" matNativeControl required (selectionChange)="deptChange($event)">
                  <mat-option *ngFor="let dept of depts" [value]="dept.id">
                    {{dept.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Item Of Service</mat-label>
                <mat-select formControlName="item_of_service_id" matNativeControl required>
                  <mat-option *ngFor="let item of items" [value]="item.id">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Sub Department</mat-label>
                <mat-select formControlName="sub_dept_id" matNativeControl required (selectionChange)="subChange($event)">
                  <mat-option *ngFor="let sub of subs" [value]="sub.id">
                    {{sub.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field class="size">
                <mat-label>Date</mat-label>
                <input formControlName="effective_date" matInput [matDatepicker]="picker">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
        </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
      <div class="post">
        <div class="title">Create OPD</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input formControlName="package_name" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Price</mat-label>
                <input formControlName="pack_price" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Tot Serve Price</mat-label>
                <input formControlName="tot_serv_price" type="number" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Net Amount</mat-label>
                <input formControlName="net_amt" type="number" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Soc</mat-label>
                <mat-select formControlName="soc_id" matNativeControl required (selectionChange)="socChange($event)">
                  <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">
                    {{soc.SOC_NAME}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Department</mat-label>
                <mat-select formControlName="dept_id" matNativeControl required (selectionChange)="deptChange($event)">
                  <mat-option *ngFor="let dept of depts" [value]="dept.id">
                    {{dept.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Item Of Service</mat-label>
                <mat-select formControlName="item_of_service_id" matNativeControl required>
                  <mat-option *ngFor="let item of items" [value]="item.id">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Sub Department</mat-label>
                <mat-select formControlName="sub_dept_id" matNativeControl required (selectionChange)="subChange($event)">
                  <mat-option *ngFor="let sub of subs" [value]="sub.id">
                    {{sub.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field class="size">
                <mat-label>Date</mat-label>
                <input formControlName="effective_date" matInput [matDatepicker]="picker">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
        </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>


    </div>
